import { Button, Shadow } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import TokenRedirectLink from '../token-redirect-link';
import { Trans } from '../../lib/i18n';
import useBreakpoint from '../../lib/use-breakpoint';

const UploadButton = ({ mediaType, ...buttonProps }) => {
  const isMobile = useBreakpoint();
  return (
    <TokenRedirectLink href="https://www.pitchero.com/account/settings/videos-photos/">
      {isMobile ? (
        <Button
          theme="solidWhite"
          {...buttonProps}
          style={{
            border: '1px solid black',
            padding: '10px',
            marginLeft: '5px',
          }}
        >
          <Trans i18nKey="media:upload">Upload</Trans>
        </Button>
      ) : (
        <Shadow shadow="dark">
          <Button theme="primary" {...buttonProps}>
            <Trans i18nKey={`media:upload_${mediaType}`}>{`Upload ${mediaType}`}</Trans>
          </Button>
        </Shadow>
      )}
    </TokenRedirectLink>
  );
};

UploadButton.propTypes = {
  mediaType: PropTypes.oneOf(['albums', 'videos']).isRequired,
};

export default UploadButton;
